import { updateUserProfile } from '../firebase/firebase';

/**
 * Auto-subscribe a user to the newsletter when they create a profile
 * @param {Object} user - The user object from authentication
 * @returns {Promise<Object>} - The updated user profile
 */
export const autoSubscribeToNewsletter = async (user) => {
  if (!user || !user.uid) {
    throw new Error('Invalid user object');
  }
  
  try {
    // Update the user profile with newsletter subscription enabled
    const updatedProfile = await updateUserProfile({
      newsletterSubscribed: true,
      subscriptionDate: new Date().toISOString(),
      subscriptionSource: 'auto_registration'
    });
    
    console.log('User auto-subscribed to newsletter:', user.email || user.uid);
    return updatedProfile;
  } catch (error) {
    console.error('Error auto-subscribing user to newsletter:', error);
    // Don't throw the error, as this is not critical functionality
    return null;
  }
};

/**
 * Check if a user is subscribed to the newsletter
 * @param {Object} userProfile - The user profile object 
 * @returns {boolean} - Whether the user is subscribed
 */
export const isSubscribedToNewsletter = (userProfile) => {
  if (!userProfile) return false;
  return Boolean(userProfile.newsletterSubscribed);
};

/**
 * Update a user's newsletter subscription status
 * @param {boolean} subscribed - Whether to subscribe or unsubscribe
 * @returns {Promise<Object>} - The updated user profile
 */
export const updateNewsletterSubscription = async (subscribed) => {
  try {
    // Update the user profile with the new subscription status
    const updatedProfile = await updateUserProfile({
      newsletterSubscribed: Boolean(subscribed),
      subscriptionDate: subscribed ? new Date().toISOString() : null,
      subscriptionSource: subscribed ? 'user_preference' : null
    });
    
    console.log(`User ${subscribed ? 'subscribed to' : 'unsubscribed from'} newsletter`);
    return updatedProfile;
  } catch (error) {
    console.error('Error updating newsletter subscription:', error);
    throw error;
  }
}; 